'use client';

import { useState } from 'react';
import { ArrowLeft, LayoutDashboard, Package, Warehouse, FileText, ClipboardList } from 'lucide-react';
import { StockDashboard } from './components/StockDashboard';
import { StockBalancePage } from './components/StockBalance';
import { ItemListPage } from './components/ItemList';
import { WarehouseListPage } from './components/WarehouseList';
import { StockEntryListPage } from './components/StockEntryList';

export type StockPage = 'dashboard' | 'balance' | 'items' | 'warehouses' | 'entries';

interface StockModuleProps {
  onBack?: () => void;
}

const menuItems: { id: StockPage; label: string; icon: typeof LayoutDashboard }[] = [
  { id: 'dashboard', label: '대시보드', icon: LayoutDashboard },
  { id: 'balance', label: '재고 현황', icon: ClipboardList },
  { id: 'items', label: '품목 관리', icon: Package },
  { id: 'warehouses', label: '창고 관리', icon: Warehouse },
  { id: 'entries', label: '입출고 내역', icon: FileText },
];

export function StockModule({ onBack }: StockModuleProps) {
  const [currentPage, setCurrentPage] = useState<StockPage>('dashboard');

  const renderPage = () => {
    switch (currentPage) {
      case 'dashboard':
        return <StockDashboard onNavigate={setCurrentPage} />;
      case 'balance':
        return <StockBalancePage />;
      case 'items':
        return <ItemListPage />;
      case 'warehouses':
        return <WarehouseListPage />;
      case 'entries':
        return <StockEntryListPage />;
      default:
        return <StockDashboard onNavigate={setCurrentPage} />;
    }
  };

  return (
    <div className="flex flex-col h-full -m-6">
      {/* 상단 네비게이션 */}
      <div className="flex items-center gap-2 px-4 py-3 bg-card border-b border-border">
        {onBack && (
          <button
            onClick={onBack}
            className="p-2 rounded-lg hover:bg-accent"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
        )}
        <h1 className="text-xl font-bold mr-6">재고 관리</h1>

        {/* 탭 메뉴 */}
        <div className="flex items-center gap-1">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = currentPage === item.id;
            return (
              <button
                key={item.id}
                onClick={() => setCurrentPage(item.id)}
                className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                  isActive
                    ? 'bg-primary text-primary-foreground'
                    : 'text-muted-foreground hover:text-foreground hover:bg-accent'
                }`}
              >
                <Icon className="w-4 h-4" />
                <span className="hidden sm:inline">{item.label}</span>
              </button>
            );
          })}
        </div>
      </div>

      {/* 페이지 컨텐츠 */}
      <div className="flex-1 overflow-auto p-6">
        {renderPage()}
      </div>
    </div>
  );
}
